import type { ToastType } from './types.ts';

// Builder-local toast() implementation. This is intentionally SEPARATE from
// the dashboard's toast (a pre-existing duplication in the legacy app that
// this port preserves rather than merges). Faithful to legacy/EMR Forms.html
// toast(): same markup (icon span + message), same class names, same 250ms
// fade-out after `dur`.
export function createToast(container: HTMLElement) {
  return function toast(msg: string, type: ToastType | string = 'info', dur = 3000): void {
    const root = container.querySelector<HTMLElement>('#toast-root');
    const el = document.createElement('div');
    el.className = 'toast ' + (type === 'ok' ? 'ok' : type === 'err' ? 'err' : '');
    el.innerHTML = `<span class="toast-icon">${({ ok: '✓', err: '✕', info: 'ℹ' } as any)[type] || 'ℹ'}</span><span>${msg}</span>`;
    root?.appendChild(el);
    setTimeout(() => { el.style.animation = 'toastOut .22s forwards'; setTimeout(() => el.remove(), 250); }, dur);
  };
}
